exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress[data-v-6f1aa2c7]{background-color:transparent;height:6px !important;border-radius:0 !important;z-index:8\n}\n.progress .loading-bar[data-v-6f1aa2c7]{-webkit-transition:width 350ms;-o-transition:width 350ms;transition:width 350ms\n}\n", ""]);

// exports
